import { Injectable } from '@angular/core';
import * as Rx from 'rxjs/Rx';

@Injectable()
export class AppService {
  fetchData(value): Rx.Observable<any> {
    return Rx.Observable
      .of(value)
      .delay(1000);
  }
}


// WEBPACK FOOTER //
// ./src/app/system/billing/new-billing/app.service.ts